import { Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider, useAuth } from './AuthContext.tsx'
import { RequireAdmin } from './ProtectedRoute.tsx'
import { useProductStore } from './store/productStore'
import LoginPage from './LoginPage.tsx'
import CatalogPage from './pages/CatalogPage'
import ProductPage from './pages/ProductPage'
import AdminPage from './pages/AdminPage'
import AddProductPage from './pages/AddProductPage'
import EditProductPage from './pages/EditProductPage'

function AppContent() {
  const { fetchProducts, fetchAdminProducts } = useProductStore()
  const location = useLocation()
  const isAdmin = location.pathname.startsWith('/admin')
  const { user, loading } = useAuth()

  useEffect(() => {
    if (loading) return  // חכה שה-auth יסתיים
    if (isAdmin) {
      fetchAdminProducts()
    } else {
      fetchProducts()
    }
  }, [isAdmin, user, loading])

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<CatalogPage />} />
      <Route path="/product/:id" element={<ProductPage />} />
      <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
      <Route path="/admin/add" element={<RequireAdmin><AddProductPage /></RequireAdmin>} />
      <Route path="/admin/edit/:id" element={<RequireAdmin><EditProductPage /></RequireAdmin>} />
      <Route path="/design-system" element={<RequireAdmin><iframe src="/design-system.html" className="w-full h-screen border-none" title="Design System" /></RequireAdmin>} />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App